// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.uttoxeterskatingclub.co.uk',
  firebase: {
    apiKey: "AIzaSyAQr4rXctdgq-rSOxDe5DNj6Cd2DcyKsuo",
    authDomain: "uttoxeter-skating-c.firebaseapp.com",
    projectId: "uttoxeter-skating-c",
    storageBucket: "uttoxeter-skating-c.appspot.com",
    messagingSenderId: "392039674966",
    appId: "1:392039674966:web:41d308210d330a109877f7",
    measurementId: "G-5GJ6E40XJF"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
